module.exports = "pegasus/assets/theme2/small/6.jpg";